

import React from 'react';
import { Skeleton } from 'antd';
import { Box, Text } from '../../shared/components';

export default function TitleContentBox({
  title, content, loading, ...rest
}) {
  return (
    <Box {...rest}>
      <Text
        style={{
          color: '#B0BAC9',
          fontFamily: 'Rubik',
          fontSize: '12px',
          fontWeight: '500',
          letterSpacing: '1.13px',
          lineHeight: '14px',
        }}
        color="gray"
      >
        {title}

      </Text>
      <Skeleton title={false} loading={loading} paragraph={{ rows: 1 }}>
        <Box>
          <Text
            style={{
              color: '#2E384D',
              fontFamily: 'Rubik',
              fontSize: '15px',
              lineHeight: '22px',
            }}
          >
            {content}

          </Text>

        </Box>
      </Skeleton>
    </Box>
  );
}
